import _ from 'underscore'
import basicController from 'servicestack/basic.controller.properties'
import $session from 'servicestack/session'
import $appConfig from 'servicestack/config'
import templateUrl from 'emun.salesrep/salesrep-dashboard.htm'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import salesrepConfig from 'emun.salesrep/salesrep.config'
import ServiceBus from 'servicestack/service-bus'
import modals from 'webmodals/modals';
import dateRangeUrl from 'emun.salesrep/date-range.htm';
import dashboardQuickReportFilters from 'emun.salesrep/quick-report-filters.htm';


class SalesRepDashboardController {
  constructor(createAutoQuery, $session, $window, $state) {
    basicController(this)
    var map = this;
    let $ctrl = this;
    $ctrl.bus = new ServiceBus();
    $ctrl.salesrepConfig = salesrepConfig;
    $ctrl.chartLoaded = false;
    $ctrl.productImage = $appConfig.productImage;
    //$ctrl.writingRepId = 32;


    //find the inside sales associated with the sales rep from the data
    //$ctrl.dailySalesQuery = createAutoQuery({
    //  url: 'QuerySalesDailyTotals.json?GroupBy=WritingRepID&InsideSales=true&SalesRepID=' + $ctrl.repId,
    //  autoLoad: true,
    //  pageSize: 1000,
    //  onLoaded: function (args) {
    //    if (args.total > 0) {
    //      $ctrl.writingRepId = args.first.writingRepID;
    //      console.info('results from query' + $ctrl.writingRepId);
    //    }
    //  }
    //});

    let options = {
      url: 'QuerySalesReps.json?IncludeSalesData=true&Id=' + $ctrl.repId,
      pageSize: 15,
      orderBy: 'Name',
      autoLoad: true,
      append: false,
      onLoaded: function (args) {
        $ctrl.rep = args.first;
        $ctrl.$state.current.customTitle = $ctrl.rep.name;
      }
    };
    $ctrl.query = createAutoQuery(options);
  }
  runReport(name) {
    const $ctrl = this;
    let url =
      $appConfig.serviceUrl + name + "?salesrepid=" + $ctrl.repId;
    return location.href = url;
  }
  runReportWithOptions(name, displayName) {
    let $ctrl1 = this;
    $ctrl1.bus = new ServiceBus();
    //console.log("run with options", name);
    return modals.open({
      templateUrl: dashboardQuickReportFilters,
      controllerAs: '$ctrl',
      controller($scope, $uibModalInstance, $session) {
        let $ctrl = this;
        var monthNum = moment().month();
        $ctrl.month = moment().month(monthNum).format("MM");
        $ctrl.startOn = moment();
        
        $ctrl.repId = $ctrl1.repId;
        $ctrl.title = "Running for " + $ctrl1.rep.name;
        $ctrl.dismiss = $ctrl.cancel = function () {
          $uibModalInstance.close();
        }
        $ctrl.runReport = function () {
          var queryString = "";
          //$uibModalInstance.close();
          //$ctrl.startOn = $ctrl.month + "/15/" + moment().year();
					//$ctrl.startOn = $ctrl.startOn.format('MM-DD-YYYY');
          var startOn = $ctrl.startOn.format('MM-DD-YYYY');
					if ($ctrl.dateType != undefined) {
						queryString += "&dateType=" + $ctrl.dateType;
					  }
          let url =
            $appConfig.serviceUrl +
            "RunReport?reportName=" + name + "&displayName=" + displayName + "&output=xlsx&repIdOverride=" + $ctrl.repId + "&startDate=" + startOn + queryString;
          return location.href = url;
        }

      },
      size: 'lg'
    }).result
  }
}


let SalesRepDashboard = {
  bindings: {
    repId: '@'
  },
  require: {
    container: '^salesrepContainer'
  },
  controller: SalesRepDashboardController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl
  }
}

export default SalesRepDashboard